/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StructuredContract } from './StructuredContract';
import {
    StructuredContractFromJSON,
    StructuredContractFromJSONTyped,
    StructuredContractToJSON,
    StructuredContractToJSONTyped,
} from './StructuredContract';

/**
 * 
 * @export
 * @interface StructuredContractResponse
 */
export interface StructuredContractResponse {
    /**
     * 
     */
    data: StructuredContract;
    /**
     * 
     */
    source: StructuredContractResponseSourceEnum;
}


/**
 * @export
 */
export const StructuredContractResponseSourceEnum = {
    Contract: 'contract',
    DefaultRule: 'default_rule',
} as const;
export type StructuredContractResponseSourceEnum = typeof StructuredContractResponseSourceEnum[keyof typeof StructuredContractResponseSourceEnum];


/**
 * Check if a given object implements the StructuredContractResponse interface.
 */
export function instanceOfStructuredContractResponse(value: object): value is StructuredContractResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    return true;
}

export function StructuredContractResponseFromJSON(json: any): StructuredContractResponse {
    return StructuredContractResponseFromJSONTyped(json, false);
}

export function StructuredContractResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StructuredContractResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': StructuredContractFromJSON(json['data']),
        'source': json['source'],
    };
}

export function StructuredContractResponseToJSON(json: any): StructuredContractResponse {
    return StructuredContractResponseToJSONTyped(json, false);
}

export function StructuredContractResponseToJSONTyped(value?: StructuredContractResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': StructuredContractToJSON(value['data']),
        'source': value['source'],
    };
}

